import React, { useState } from 'react';
import { CreatePlaylistResponse } from '../types/playlist';
import { createPlaylist } from '../services/playlistApi';

interface Props {
  artistName: string;
  selectedSongs: string[];
}

export const CreatePlaylistPanel: React.FC<Props> = ({ artistName, selectedSongs }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<CreatePlaylistResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleCreate = async () => {
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const data = await createPlaylist(artistName, selectedSongs);
      setResult(data);
    } catch (err: any) {
      setError(err.message || 'Failed to create playlist');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#fff', borderRadius: '8px', padding: '16px', border: '1px solid #eee' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: '15px' }}>Create Spotify Playlist</h3>
      <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#666' }}>
        {selectedSongs.length > 0
          ? `${selectedSongs.length} songs selected`
          : 'No songs selected'}
      </p>

      <button
        onClick={handleCreate}
        disabled={loading || selectedSongs.length === 0}
        style={{
          background: selectedSongs.length === 0 ? '#ccc' : '#1DB954',
          color: '#fff',
          border: 'none',
          borderRadius: '20px',
          padding: '10px 20px',
          cursor: selectedSongs.length === 0 ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          width: '100%',
        }}
        aria-label="Create Spotify Playlist"
      >
        {loading ? 'Creating…' : 'Create Spotify Playlist'}
      </button>

      {error && (
        <div role="alert" style={{ marginTop: '12px', color: '#c00', fontSize: '13px' }}>
          {error}
        </div>
      )}

      {result && (
        <div style={{ marginTop: '12px' }}>
          <p style={{ color: '#1DB954', fontWeight: 600, margin: '0 0 6px', fontSize: '14px' }}>
            ✓ Playlist created — {result.trackCount} tracks added
          </p>
          <a
            href={result.playlistUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1DB954', fontSize: '13px' }}
            aria-label="Open in Spotify"
          >
            Open in Spotify ↗
          </a>

          {result.skippedSongs.length > 0 && (
            <div style={{ marginTop: '8px' }}>
              <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#888' }}>
                {result.skippedSongs.length} song{result.skippedSongs.length > 1 ? 's' : ''} not found on Spotify:
              </p>
              <ul style={{ margin: 0, paddingLeft: '16px' }}>
                {result.skippedSongs.map(s => (
                  <li key={s} style={{ fontSize: '12px', color: '#888' }}>{s}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
